/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from "react";
import {Toaster} from "react-hot-toast";
import {Link} from "react-router-dom";
import "jspdf-autotable";
import Pagination from "../../../Components/Common/Pagination";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import Loader from "../../../Components/Common/Loader";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import * as XLSX from "xlsx";
import EditPicture from "../../../Components/Students/EditPicture";
import SchoolContext from "../../../Context/SchoolContext";
import Select from "react-select";
import PrintFilterForm2 from "../../../Components/Students/AdminProfile/PrintFilterForm2";

function NoPhotoStudentsPage() {
  
  const [modal, setModal] = useStateCallback(false);
  const [noPhotoList, setNoPhotoList] = useState([]);
  const [printableList, setPrintableList] = useState([]);
  const {schoolList} = useContext(SchoolContext); 
  const [query, setQuery] = useState("");
  const [school, setSchool] = useState("");
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [first, setFirst] = useState("");

  const getStudentList = async () => {
    setNoPhotoList([]);
    setLoading(true);
    const server_response = await ajaxStudent.listAllNoPhotoStudents(page);
    setLoading(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages);
      setNoPhotoList(server_response.details.list || []);
    } else {
      setNoPhotoList([]);
    }
  };

  const searchStudentList = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxStudent.searchAllNoPhotoStudents(page, school, query);
    setLoading2(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
      setMeta(server_response.details.meta.totalPages);
      setNoPhotoList(server_response.details.list || []);
    } else {
      setNoPhotoList([]);
    }
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };
  
  useEffect(() => {
    if (query || school) {
      searchStudentList();
    }else {
      getStudentList(page);
    }
  }, [page]);

  const editPicture = (e, item) => {
    setModal(false, () =>
      setModal(
        <EditPicture
          userID={item.user_id}
          g={getStudentList}
          isOpen={true}
        />
      )
    );
  };

  const setStudents = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("")
    setPage(1);
    getStudentList(1);
  };

  const refreshData = () => {
    getStudentList(1);
  };

  const handleModal = () => {
    setModal(false, () =>
      setModal(
        <PrintFilterForm2
          g={setPrintableList}
          h={exportToExcel}
          printableList={printableList}
          isOpen={true}
        />
      )
    );
  };

  const exportToExcel = (data) => {
        const worksheetData = (data || []).map((item) => ({
          "Names": item.full_name,
          "School": item.school,
          "Student Class": item.group,
          "Pocket Money": item.pocket_money_balance <= 0 ?"NIL":"AVAILABLE"
         }));
      
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Student List (Missing Photos)");
      
        XLSX.writeFile(workbook, "no_photo_student_list.xlsx");
  };

  
  return (

    <AppContainer title="Students Without Photos">
        <Toaster position="top-center" reverseOrder={false} />
        {modal}
        <div className="row">
            <div className="col-lg-12">
                <div className="card custom-card">
                    <div className="card-body map-card">
                        <div class="heading-layout1 mg-b-25">
                            <TableHeader
                                title="Students Without Photos"
                                subtitle="List of all the students with missing profile images sorted in ascending order"
                            />
                            <div class="dropdown">
                                <Link class="dropdown-toggle"  role="button" data-toggle="dropdown" aria-expanded="false">...</Link>

                                <div class="dropdown-menu dropdown-menu-right">
                                    <Link class="dropdown-item" onClick={handleModal} ><i class="fas fa-file-export"></i>Export</Link>
                                    <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link> 
                                </div>
                            </div>
                        </div>

                        <form className="mg-t-20" onSubmit={searchStudentList}>
      <div className="row gutters-8">
        <div className="col-9-xxxl col-lg-9 col-12 form-group">
          <div className="row">
             <div className="col-lg-6 mt-2">
        <input
                  type="text"
                  value={query} onChange={(e) => setQuery(e.target.value)}
                  placeholder="Enter first or last name of student..."
                  style={{border: "1px solid grey"}}
                  className="form-control"
                />
        </div>
          
            <div className="col-lg-6 mt-2">
            <Select
                onChange={(e) => setSchool(e.school_id)}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                        school === "" ? null
                          : Array.isArray(schoolList) &&
                            schoolList.find((value) => value.school_id === school)
                      }
                
            />
            </div>
            
            
            
          </div>
        </div>

        <div className="col-3-xxxl col-lg-3 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={setStudents}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini mt-2"
          >
            RESET
          </button>
        </div>
      </div>
      </form>

                        <div className="border-top mt-3"></div>
                        <div className="table-responsive">
                            {loading || loading2 ? (
                                <Loader />
                            ) : (
                                <table className="table display data-table text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Name</th>
                                            <th>School</th>
                                            <th>Class</th>
                                            <th>Pocket Money</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {noPhotoList.length > 0 ? (
                                            noPhotoList.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{width:"5px"}}>{index + first + 1}</td>
                                                <td>
                                                    <Link to={`/students/profile/${item.student_id}/${item.user_id}`}>
                                                    {item.full_name}
                                                    </Link>
                                                </td>
                                                <td className="text-dark">{item.school}</td>
                                                <td className="text-dark">{item.group}</td>

                                                <td>
                                  {item.pocket_money_balance <= 0 ? (
                                    <span className="badge badge-danger">NIL</span>
                                  ) : (
                                    <span className="badge badge-success">AVAILABLE</span>
                                  )}
                                </td>

                                                <td>
                                                    
                                                        <Link
                                                            className="btn btn-primary"
                                                            onClick={(e) => editPicture(e, item)}
                                                        >
                                                            <i className="fas fa-camera" /> Take Picture{" "}
                                                            
                                                        </Link>
                                                    
                                                </td>
                                            </tr>
                                            ))
                                        ) : 
                                        (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "center" }}>
                                                    No students without photos yet.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                    
                    </div>
                </div>
            </div>
        </div>
    </AppContainer>
  );
}

export default NoPhotoStudentsPage;